import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

declare global {
    interface Window {
        recaptchaOptions: {};
    }
}

window.recaptchaOptions = {
    enterprise: true,
};

export function Recaptcha(props: { recaptchaRef: React.RefObject<ReCAPTCHA> | any }) {
    const siteKey = process.env.REACT_APP_SITE_KEY;
    return <ReCAPTCHA ref={props.recaptchaRef} size="invisible" sitekey={siteKey!} />;
}
